import { api } from '../api/client';
import { store } from '../state/store';
import { formatDisplayDate, parseISODate } from '../utils/date';
import { openEraModal } from './eras';

export function renderErasLegend(): void {
  const container = document.getElementById('eras-legend-list');
  const section = document.getElementById('eras-legend-section');
  if (!container || !section) return;

  const eras = store.meta.eras;
  if (eras.length === 0 && !store.meta.isAdmin) {
    section.classList.add('hidden');
    return;
  }
  section.classList.remove('hidden');
  container.innerHTML = '';

  if (eras.length === 0 && store.meta.isAdmin) {
    const emptyMsg = document.createElement('div');
    emptyMsg.className = 'text-muted';
    emptyMsg.style.fontSize = '0.8rem';
    emptyMsg.textContent = 'No chapters defined yet. Click "+ Add Era" to create your first life chapter.';
    container.appendChild(emptyMsg);
    return;
  }

  eras.forEach((era) => {
    const pill = document.createElement('div');
    pill.className = 'era-pill';
    if (store.highlightedEraId === era.id) {
      pill.style.borderColor = era.color;
      pill.style.backgroundColor = `${era.color}22`;
    }

    const dot = document.createElement('span');
    dot.className = 'era-color-dot';
    dot.style.backgroundColor = era.color;

    const title = document.createElement('strong');
    title.textContent = era.title;

    const dates = document.createElement('span');
    dates.className = 'era-pill-dates';
    const startStr = formatDisplayDate(parseISODate(era.start_date));
    const endStr = era.end_date ? formatDisplayDate(parseISODate(era.end_date)) : 'Present';
    dates.textContent = `(${startStr} – ${endStr})`;

    pill.appendChild(dot);
    pill.appendChild(title);
    pill.appendChild(dates);

    if (era.is_private) {
      const privateBadge = document.createElement('span');
      privateBadge.className = 'badge-private';
      privateBadge.textContent = 'Private';
      pill.appendChild(privateBadge);
    }

    // Admin Action Buttons (Edit & Delete)
    if (store.meta.isAdmin) {
      const actions = document.createElement('span');
      actions.className = 'era-pill-actions';

      const editBtn = document.createElement('button');
      editBtn.className = 'era-action-btn';
      editBtn.title = 'Edit Chapter';
      editBtn.innerHTML = '✏️';
      editBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        openEraModal(era);
      });

      const deleteBtn = document.createElement('button');
      deleteBtn.className = 'era-action-btn delete-btn';
      deleteBtn.title = 'Delete Chapter';
      deleteBtn.innerHTML = '✕';
      deleteBtn.addEventListener('click', async (e) => {
        e.stopPropagation();
        if (!confirm(`Are you sure you want to delete the chapter "${era.title}"?`)) return;
        try {
          await api.deleteEra(era.id);
          const filtered = store.meta.eras.filter((e) => e.id !== era.id);
          store.setEras(filtered);
        } catch (err) {
          alert(`Failed to delete chapter: ${String(err)}`);
        }
      });

      actions.appendChild(editBtn);
      actions.appendChild(deleteBtn);
      pill.appendChild(actions);
    }

    // Click behavior on pill toggles highlight
    pill.addEventListener('click', () => {
      store.setHighlightedEra(era.id);
    });

    pill.title = 'Click to highlight in calendar';
    container.appendChild(pill);
  });
}
